import { render, staticRenderFns } from "./AllGoals.vue?vue&type=template&id=73c0ca7e&scoped=true&lang=pug"
import script from "./AllGoals.vue?vue&type=script&lang=js"
export * from "./AllGoals.vue?vue&type=script&lang=js"
import style0 from "./AllGoals.vue?vue&type=style&index=0&id=73c0ca7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0ca7e",
  null
  
)

export default component.exports